import React, { useEffect, useState } from 'react';
import loginBackground from '../../../../assets/images/login-background.png';
import vamosLogo from '../../../../assets/images/vamos-horizontal-logo.png';
import { ToastProvider } from '../../providers/ToastProvider';
import SetNewPasswordForm from '../../componentsV2/PasswordReset/SetNewPasswordForm';
import ResetPasswordRequestForm from '../../componentsV2/PasswordReset/ResetPasswordRequestForm';
import PageFooter from '../../componentsV2/PageFooter/PageFooter';
import { validateResetPasswordToken } from '../../utils/api/passwordReset';
import { withContextProvider } from '../../hoc';
import { useToasts } from '../../hooks/useToasts';

const SetNewPasswordPage = () => {
  const { showToast } = useToasts();
  const [isValid, setIsValid] = useState(null);

  const { location } = window;
  const fixedSearch = location.search.replace(/&amp;/g, '&');
  const searchParams = new URLSearchParams(fixedSearch);
  const token = searchParams.get('reset_password_token');
  // Invitation links carry this flag so API validation can apply invitation TTL.
  const isInvitation = searchParams.get('invitation') === 'true';

  useEffect(() => {
    // Reset state on each token/url change to avoid stale UI flashes.
    setIsValid(null);

    const check = async () => {
      const res = await validateResetPasswordToken({ token, invitation: isInvitation });

      if (res.success) {
        setIsValid(true);
        return;
      }

      if (isInvitation) {
        // Invitation links use the same reset-password token as forgot password,
        // but invalid outcomes need different destinations:
        // - expired by time -> expired verification page
        // - already used / otherwise invalid -> already-confirmed page
        window.location.href = res.reason === 'expired'
          ? '/verify-email?token=expired'
          : '/users/confirmation/new';
        return;
      }

      const message = res.errors?.[0] || 'Reset password token has expired or is invalid.';

      setIsValid(false);
      showToast({ message, type: 'error' });
    };

    check();
  }, [token, isInvitation, showToast]);

  let content = null;
  // Keep the page blank while token validation is in flight so users do not see
  // the forgot-password form flash before invitation redirects complete.
  if (isValid === true) {
    content = <SetNewPasswordForm />;
  } else if (isValid === false) {
    content = <ResetPasswordRequestForm />;
  }

  return (
    <div
      className="min-h-screen w-screen bg-no-repeat bg-top-0 overflow-y-auto flex flex-col justify-between"
      style={{ backgroundImage: `url(${loginBackground})` }}
    >
      <div className="flex flex-col items-end">
        <div className="flex flex-col items-center justify-center w-full md:w-3/4 xl:w-1/3 mr-0 md:mr-47 mx-auto mb-8">
          <img
            src={vamosLogo}
            alt="Vamos horizontal logo"
            className="w-100 h-36.5 flex-shrink-0"
          />
          {content}
        </div>
      </div>
      <PageFooter />
    </div>
  );
};

export default withContextProvider(ToastProvider)(SetNewPasswordPage);
